@if(mainStoreService.adminWhiteLabel) {
    <div class="flex min-h-screen w-full overflow-hidden ">
        <!-- Sidebar -->
        <app-admin-sidebar></app-admin-sidebar>
<!--        <div class="hidden lg:fixed lg:z-50 lg:flex lg:w-72 lg:flex-col">-->
<!--            <div class="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-card px-6 pb-4">-->
<!--                <div class="h-16 leading-10 shrink-0 text-center text-normal">-->
<!--                    Cybfed-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

        <div class=" min-h-screen flex-1">
<!--            <div class="sticky top-0 z-40 lg:mx-auto">-->
<!--                <div class="flex h-16 items-center gap-x-4 border-b border-gray-200 bg-card px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-0 lg:shadow-none">-->
<!--                    &lt;!&ndash; Separator &ndash;&gt;-->
<!--                    <div class="w-full">-->
<!--                        <app-admin-side-bar class="w-full mt-5"></app-admin-side-bar>-->
<!--                    </div>-->
<!--                    <div class="h-6 w-px bg-gray-200 lg:hidden" aria-hidden="true"></div>-->
<!--                    <div class="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">-->
<!--                        <form class="relative flex flex-1" >-->
<!--                        </form>-->
<!--                        <div class="flex items-center gap-x-4 lg:gap-x-6">-->
<!--                            <app-notifications-dropdown></app-notifications-dropdown>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

            <main class="py-10">
                <div class="mx-auto px-4 sm:px-6 lg:px-8">
                    <router-outlet></router-outlet>
                </div>
            </main>
        </div>
    </div>

}
